import React, { useMemo } from 'react'

import { useUser } from '../../contexts/user/user-context'
import { Header } from './header'

export function HeaderContainer() {
    //TODO: Probably create a type for this
    const { userProfile }: any = useUser()

    const [firstName, lastName] = useMemo(() => {
        if (userProfile && userProfile.getUserProfile) {
            return [
                userProfile.getUserProfile.firstName,
                userProfile.getUserProfile.lastName,
            ]
        } else {
            return ['', '']
        }
    }, [userProfile])

    return (
        <Header
            firstName={firstName}
            lastName={lastName}
            connectedMetamask={false}
        />
    )
}
